import { makeStyles } from '@mui/styles';
import React from 'react';
import { Grid, Tooltip } from '@mui/material';
import RecordList from '../components/RecordList'
import { ReactComponent as LinkOutIcon } from '../chat/icons/link_out.svg'
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import TripChatChannelsToolbar from './TripChatChannelsToolbar';
import { unarchive_channel } from '../chat/utils/chat_utils';

const useStyles = makeStyles((theme) => ({
    root: {
        border: 'solid 1px #D8D8D8',
        margin: '0 1rem',
        //paddingTop: '1.5rem',
        borderRadius: '0 0 12px 12px',
        [theme.breakpoints.down('md')]: {
            paddingBottom: '4rem',
            border: 0,
            margin: 0,
        },
        minHeight: `calc(${theme.cp.contentHeight} - 13.5rem)`,
        marginBottom: '1rem',
    },
}));

const TripChatList = (props) => {
    const classes = useStyles();
    const trip = props.trip;
    const trip_chat_list_resource = 'trip_chat_list';
    const [channelListQuery, setChannelListQuery] = React.useState("");
    const [dateRange, setDateRange] = React.useState({ start: null, end: null });
    const [tagFilters, setTagFilters] = React.useState([]);
    const [relatedLoading, setRelatedLoading] = React.useState(null);

    const apiFilters = React.useMemo(() => {
        const filters = [];
        if (dateRange.start || dateRange.end) {
            // One picked day filters that day, as on the trip's Users tab.
            filters.push({ field: 'travel_date_range', value: [dateRange.start || dateRange.end, dateRange.end || dateRange.start] });
        }
        if (tagFilters.length > 0) {
            filters.push({ field: 'tag_ids', value: tagFilters.map((t) => t.id).join(',') });
        }
        return filters.length > 0 ? filters : null;
    }, [dateRange, tagFilters]);

    return (
        <div className={classes.root}>
            <Grid item xs={true} style={{ height: '75vh', width: '100%', fontSize: '80%', paddingBottom: '5rem', paddingLeft: '1em', paddingRight: '1em' }}>
                <TripChatChannelsToolbar 
                    tripId={trip.id}
                    onQueryChange={setChannelListQuery}
                    channelListQuery={channelListQuery}
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    tagFilters={tagFilters}
                    setTagFilters={setTagFilters}
                    isSmallScreen={props.isSmallScreen}
                />
                <RecordList
                    className={classes.recordList}
                    resource={trip_chat_list_resource + '/' + trip.id.toString()}
                    //apiFilters={chatAPIFilters}
                    //hiddenAPIFilters={chatAPIFilters}
                    checkboxSelection={false}
                    disableSelectionOnClick={true}
                    // Unsorted by default: the server's default order starts at today.
                    sortModel={[]}
                    query={channelListQuery}
                    apiFilters={apiFilters}
                    isSmallScreen={props.isSmallScreen}
                    disableListBorder={false}
                    limitHeightForMobile={'40vh'}
                    page={props.staffLastDataGridPage}
                    setLastDataGridPage={props.setStaffLastDataGridPage}
                    perPage={25}
                    setLastDataGridPerPage={props.setStaffLastDataGridPerPage}
                    getRowHeight={() => 'auto'}
                    relatedLoading={relatedLoading}
                    //borderDisplay="none"
                    //headerDisplay="none"
                    //headerHeight={0}
                    columns={[
                        {
                            field: 'travel_date',
                            headerName: 'Date',
                            sortable: true,
                            flex: 1,
                            minWidth: 100,
                            align: 'left',
                        },
                        {
                            field: 'tour_tags',
                            headerName: 'Chat-Specific Tags',
                            sortable: false,
                            flex: 5,
                            renderCell: (p) => {
                                const raw = p.row.tour_tags || [];
                                const tags = [...raw].sort(function (x, y) {
                                    return x.category === 'departure' ? -1 : y.category === 'departure' ? 1
                                        : x.category === 'guide' ? -1 : y.category === 'guide' ? 1
                                            : x.category === 'bus_number' ? -1 : y.category === 'bus_number' ? 1
                                                : 0;
                                });
                                return (
                                    <span style={{ display: 'inline' }}>
                                        {tags.map((tag) => (
                                            <span
                                                key={tag.id != null ? String(tag.id) : `${tag.category}-${tag.name}`}
                                                style={{
                                                    fontSize: '.88em',
                                                    padding: 1,
                                                    marginLeft: 4,
                                                    color: 'black',
                                                    background: '#EAF4FF',
                                                    borderRadius: 3,
                                                    display: 'inline-block',
                                                }}
                                            >
                                                {tag.name}
                                            </span>
                                        ))}
                                    </span>
                                );
                            },
                        },
                        {
                            field: 'buttons',
                            headerName: 'Open/Unarchive',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                            filterable: false,
                            flex: 1,
                            renderCell: (p) => {
                                return (
                                    <Tooltip title={p.row.is_archived ? "Unarchive and open" : "Open"}>
                                    <span style={{ fontWeight: 600, fontSize: ".85em", cursor: "pointer" }}>
                                        <span onClick={p.row.is_archived ? async () => { setRelatedLoading(true); await unarchive_channel(p.row.id); p.row.is_archived = false; window.open("/chat/" + p.row.id.toString() + "/conversations", '_blank'); setRelatedLoading(false)} : () => {window.open("/chat/" + p.row.id.toString() + "/conversations", '_blank')}}>{p.row.is_archived ? <UnarchiveOutlinedIcon style={{ color: 'rgba(0, 0, 0, .5)', fontSize: "2em" }} /> : <LinkOutIcon />}</span>
                                    </span>
                                    </Tooltip>)
                            }
                        },                        
                    ]}
                />
            </Grid>
        </div >
    );
};

export default TripChatList;
